
<app-top-bar/>
<router-outlet></router-outlet>

